import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { forEach, isEmpty } from 'lodash';
import { ExporterService } from 'app/services/exporter.service';
import { fuseAnimations } from '@fuse/animations';
import { takeUntil} from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'properties-add-to-portal',
  templateUrl: './properties-add-to-portal.component.html',
  styleUrls: ['./properties-add-to-portal.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None
})
export class PropertiesAddToPortalComponent implements OnInit {
  portals: any;
  loading: boolean = false;
  currentBucket : any;
  propertyIds: any;
  model: String;
  private _unsubscribeAll: Subject<any> = new Subject();
  displayedColumns: string[] = ['name', 'actions'];
  constructor(
    private _exporterService: ExporterService,
    public matDialogRef: MatDialogRef<PropertiesAddToPortalComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: any
  ) {
    if (!isEmpty(this._data)) {
      if (this._data?.model) {
        this.model = this._data.model;
      }
      this.getAllCarts();
      if (this._data?.propertyIds) {
        this.propertyIds = this._data.propertyIds;
      }
    }
  }

  ngOnInit(): void {

  }
  // updateUserCarts(bucket: any): any {
  //   if (typeof bucket.proerty_ids === 'undefined') {
  //     bucket.proerty_ids = [];
  //   }
  //   if (this._data.length > 0) {
  //     forEach(this._data, (pid) => {
  //       if ((bucket.proerty_ids.indexOf(pid) !== -1) === false) {
  //         bucket.proerty_ids.push(pid);
  //       }
  //     });
  //     if (bucket.proerty_ids) {
  //       this._exporterService.updateExporter(bucket).subscribe((data) => {
  //         // this.matDialogRef.close();
  //       });
  //     }
  //   }

  // }

  addPropertyBucket(bucket: any): any {
    this.currentBucket = bucket._id;
    this.loading = true;
    if (this.propertyIds.length > 0) {
      if (this.model === 'properties') {
        if (typeof bucket.proerty_ids === 'undefined') {
          bucket.property_ids = [];
        }
        forEach(this.propertyIds, (pid) => {
          if ((bucket.proerty_ids.indexOf(pid) !== -1) === false) {
            bucket.proerty_ids.push(pid);
          }
        });
      } else {
        if (typeof bucket.commercial_ids === 'undefined') {
          bucket.commercial_ids = [];
        }
        forEach(this.propertyIds, (pid) => {
          if ((bucket.commercial_ids.indexOf(pid) !== -1) === false) {
            bucket.commercial_ids.push(pid);
          }
        });
      }
      const propertiesIds = this.model === 'properties' ? bucket.proerty_ids : bucket.commercial_ids;
      if (propertiesIds) {
        this._exporterService.addPropertyToBucket(bucket.cart_name, propertiesIds, bucket._id, this.model)
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((data) => {
          if(data){
            this.getAllCarts();
            this.loading = false;
          }
        });
      }
    }
  }

  removePropertyFromBucket(bucket) {
    this.currentBucket = bucket._id;
    this.loading = true;
    if (this.model === 'properties') { 
      bucket.proerty_ids = bucket.proerty_ids.filter(value => !this.propertyIds.includes(value));
    } else {
      bucket.commercial_ids = bucket.commercial_ids.filter(value => !this.propertyIds.includes(value));
    }
    this._exporterService.updateExporter(bucket).subscribe((data) => {
      if (data) {
        this.getAllCarts();
        this.loading = false;
      }
    });
  }

  getAllCarts() {
    // TODO
    /**
     * ticket 2829
     * ticket 2878
     * at that time we do not have the script which convert resd user cart into comm user cart
     * so meanwhile using this
     */
    if (this.model === 'properties') { 
      this._exporterService.getUserCarts().subscribe((data) => {
        this.portals = data;
      });
    } else {
      this._exporterService.getCommercialUserCarts().subscribe((data) => {
        this.portals = data;
      });
    }
  }

  checkBucketProperties(bucket: any): any {
    let ids = [];
    if (this.model === 'properties') {
      ids = typeof bucket.proerty_ids === 'undefined' ? [] : bucket.proerty_ids;
    } else {
      ids = typeof bucket.commercial_ids === 'undefined' ? [] : bucket.commercial_ids;
    }
    return this.propertyIds.some(item => ids.includes(item));
  }

}
